import { render, staticRenderFns } from "./SubscriptionTable.vue?vue&type=template&id=3b74d4b2&scoped=true&"
import script from "./SubscriptionTable.vue?vue&type=script&lang=js&"
export * from "./SubscriptionTable.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionTable.vue?vue&type=style&index=0&id=3b74d4b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74d4b2",
  null
  
)

export default component.exports